"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownDivider = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
function DropdownDivider(props) {
    var classes = styles_1.useStyles(styles).classes;
    return react_1.default.createElement("li", __assign({ className: classes.divider, role: 'separator' }, props));
}
exports.DropdownDivider = DropdownDivider;
DropdownDivider.defaultProps = {};
var styles = function (theme) { return ({
    divider: {
        borderBottom: "1px solid " + theme.pallete.divider,
        marginBottom: '0.5rem',
    },
}); };
//# sourceMappingURL=DropdownDivider.js.map